import { Hotel } from '@cardo/types';

export function formatInt(amount: number) {
  return amount.toLocaleString('en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}

export function getHotelDefaultImage({
  hotel,
  prefer = 'cover',
}: {
  hotel?: Hotel | null;
  prefer?: 'featured' | 'cover';
}) {
  if (!hotel) return null;

  const { coverImage, featuredImage, twImages } = hotel.attributes;

  if (prefer === 'cover') {
    if (coverImage?.data) return coverImage.data;
    if (featuredImage?.data) return featuredImage.data;
  }

  if (prefer === 'featured') {
    if (featuredImage?.data) return featuredImage.data;
    if (coverImage?.data) return coverImage.data;
  }

  if (twImages && twImages.length > 0) {
    const exteriorImage = twImages.find(
      ({ caption }) =>
        caption?.toLowerCase()?.includes('exterior') ||
        caption?.toLowerCase()?.includes('entrance'),
    );
    const lobbyImage = twImages.find(({ caption }) =>
      caption?.toLowerCase()?.includes('lobby'),
    );

    const twImage = exteriorImage || lobbyImage || twImages[0];

    return {
      id: parseInt(twImage.caption, 36), // represents the caption as a number from the base 36 string
      attributes: {
        name: '',
        caption: twImage.caption,
        url: twImage.url,
      },
    };
  }

  return null;
}
